import { clsx } from "clsx";
import BgImage from "./BgImage";
import SmartLink from "./SmartLink";
import { routes } from "@prmf/site-router";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

type CardProps = {
  title: string;
  text: string;
  image: string;
  link: string;
  reverse?: boolean;
};

type Props = {
  text: string;
  image: string;
  link: string;
};

function Card(props: CardProps) {
  return (
    <aside className="grid max-w-lg grid-cols-2 gap-2 rounded p-4 shadow-xl">
      <div className="space-y-4 place-self-center p-4">
        <h4 className="border-b text-lg font-light">{props.title}</h4>
        <p className="min-h-[80px] text-xs">{props.text}</p>
        <SmartLink
          className="block w-max rounded-full border border-black px-4 py-2 text-xs font-medium"
          to={props.link}
        >
          {props.link.startsWith("http") ? (
            <div className="flex items-center gap-2">
              <span>Launch</span>
              <ArrowTopRightOnSquareIcon className="h-4 w-4" />
            </div>
          ) : (
            "Contact"
          )}
        </SmartLink>
      </div>
      <BgImage
        className={clsx("aspect-square rounded", props.reverse && "row-end-1")}
        src={props.image}
      />
    </aside>
  );
}

export default function (props: Props) {
  return (
    <div className="py-24">
      <div className="container flex justify-center gap-4 max-lg:flex-col max-lg:items-center">
        <Card title="Interactive brochure" {...props} reverse />
        <Card
          title="Get in touch"
          text="Please use the ‘contact us’ form to start a conversation about your next project."
          image="/media/assets/brochure-contact.jpg"
          link={routes.contact}
        />
      </div>
    </div>
  );
}
